// extracted by mini-css-extract-plugin
export default {"form":"OcCKZQ","separator":"o_Jul6","footer":"dFDgWT"};